import React, { useEffect, useState } from 'react';

import ReactTable from '../../../common/Table';
import ShippingForm from '../../Forms/ShippingForm';
import Reprint from '../../Forms/Reprint';
import OrderPackage from "../../../../models/OrderPackage";
import Student from "../../../../models/Student";
import School from "../../../../models/School";
import Package from "../../../../models/Package";
import Cart from "../../../../models/Cart";
import Order from "../../../../models/Order";
import Option from "../../../../models/Option";
import Modal from '../../../common/Modal';
import CustomerCart from "../../../CustomerCart";
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import styles from './Table.module.sass'
import ExportModal from './ExportModal'
import Grid from "../../../Grid";
import { onExportSeasonChange, orderTableFilters, selectedExportSeason } from '../../../../utils/exportSchoolFilter';

const OrderTable = () => {
  const [orderItems, setOrderItems] = useState([]);
  const [filters, setFilters] = useState({});
  // The Season box in the control bar: blank = every season. The table follows
  // it so it lists the same work the cards count.
  const [season, setSeason] = useState(selectedExportSeason());

  const [isOpen, setIsOpen] = useState(false);
  const [rowInfo, setRowInfo] = useState({});

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  useEffect(() => {
    OrderPackage
      .includes(['package', 'api_option', 'options'])
      .includes({ student: 'school', extras: 'prices',
        cart: ['orders', { orderPackages: ['background', 'studentImage', 'extras', 'options',
            { apiOption: 'imageTypes' }] }] })
      // Print work only, narrowed to the Season box: see orderTableFilters.
      .where(orderTableFilters(season))
      .order({ id: 'DESC' })
      .all()
      .then(response => {
        setOrderItems(response.data);
      });
  }, [season]);

  useEffect(() => onExportSeasonChange(setSeason), []);

  const handleOpen = (rowInfo) => {
    console.log(rowInfo);
    setRowInfo(rowInfo);
    setIsOpen(true);
  }

  const onRowClick = ({ rowInfo }) => {
    return {
      onClick: () => {
        setRowInfo(rowInfo);
        setIsOpen(true);
      }
    }
  }

  const renderModal = () => {
    if (!isOpen) return;

    return (
      <Modal
        modalIsOpen={isOpen}
        closeModal={closeModal}
        contentLabel="Ship"
        headerText="Ship Item"
      >
        <CustomerCart displayPurchaseInfo orderTable={true}
                      editable={false} providedCart={rowInfo.cart} order={rowInfo.cart.orders[0]} />
      </Modal>
    )
  }

  const columns = [
    {
      Header: 'Item ID',
      accessor: 'id',
    },
    {
      Header: 'Parent Name',
      accessor: (rowInfo) => {
        return (
          <span>
           {rowInfo.cart.orders[0].fullName()}
          </span>
        )
      }
    },
    {
      Header: 'Student Name',
      accessor: (rowInfo) => {
        return (
          <span>
           {rowInfo.student.fullName()}
          </span>
        )
      }
    },
    {
      Header: 'School',
      accessor: (rowInfo) => {
        return (
          <span>
           {rowInfo.student.school && rowInfo.student.school.name}
          </span>
        )
      }
    },
    {
      Header: 'Pricelist',
      accessor: (rowInfo) => {
        return (
          <span>
           {rowInfo.package.slug}
          </span>
        )
      }
    },
    {
      Header: 'Package',
      accessor: (rowInfo) => {
        return (
          <span>
            {rowInfo.option().name}
          </span>
        )
      }
    },
    {
      Header: 'Order Type',
      accessor: (rowInfo) => {
        return (
          <span>
           {rowInfo.appointmentTime && rowInfo.appointmentTime.length ? 'Appointment' : 'Purchase'}
          </span>
        )
      }
    },
    {
      Header: ' ',
      Cell: ({ row }) => {
        return (
          <DropdownButton title="Actions" className={styles.actionButton}>
            <Dropdown.Item onClick={() => handleOpen(row.original)}>View Item</Dropdown.Item>
            <Dropdown.Item href={`/admin/orders/${row.original.cart.orders[0].id}/edit`} target="_blank">Edit Item</Dropdown.Item>
            <ShippingForm isLink={true} orderPackageId={row.original.id} />
          </DropdownButton>
        )
      }
    }
  ]

  return (
    <div>
      <hr />
      {renderModal()}
      <Grid container justify='left' spacing={2}>
        <Grid item xs={2} md={2}>
          <ShippingForm />
        </Grid>

        <Grid item xs={2} md={2}>
          <Reprint />
        </Grid>
      </Grid>
      <br/>
      <br/>
      <ExportModal />
      <ReactTable
        columns={columns}
        data={orderItems}
      />
    </div>
  )
}

export default OrderTable;
